import { IconMoon, IconSun } from '@tabler/icons-react';
import { useThemeStore } from '../../state/themeStore.ts';

export function ThemeToggle() {
  const isDark = useThemeStore((s) => s.isDark);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);

  return (
    <button
      onClick={toggleTheme}
      className="grid h-9 w-9 place-items-center rounded-xl border border-line bg-surface text-fg-2 shadow-sm transition duration-200 ease-standard hover:bg-grid"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark ? <IconSun className="h-5 w-5" /> : <IconMoon className="h-5 w-5" />}
    </button>
  );
}
